<script>
    import {location, replace} from 'svelte-spa-router';
    import { getAuth, onAuthStateChanged } from "firebase/auth";

    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
        if (user) {
            // User is signed in, see docs for a list of available properties
            // https://firebase.google.com/docs/reference/js/firebase.User
            const uid = user.uid;
        } else {
            replace('/');
        }
    });
</script>

<h1 class="is-size-3 mt-3 has-text-centered"><strong>The Next Generation</strong></h1>
<h6 class="is-size-6 has-text-centered">SMS - By JohnFromme Ventures</h6>
<div class="tabs is-medium is-centered mb-4">
    <ul>
        {#if $location == "/dashboard"}
        <li class="is-active"><a href="#/dashboard">Dashboard</a></li>
        {:else}
        <li><a href="#/dashboard">Dashboard</a></li>
        {/if}

        {#if $location == "/contacts"}
        <li class="is-active"><a href="#/contacts">Contacts</a></li>
        {:else}
        <li><a href="#/contacts">Contacts</a></li>
        {/if}

        {#if $location == "/settings"}
        <li class="is-active"><a href="#/settings">Settings</a></li>
        {:else}
        <li><a href="#/settings">Settings</a></li>
        {/if}

        {#if $location == "/calculator"}
        <li class="is-active"><a href="#/calculator">Cost Calculator</a></li>
        {:else}
        <li><a href="#/calculator">Cost Calculator</a></li>
        {/if}
    </ul>
</div>

<style>
    a:hover {
        text-decoration: none;
    }
</style>